import { render, staticRenderFns } from "./MyProduct.vue?vue&type=template&id=4e68e8cc"
import script from "./MyProduct.vue?vue&type=script&lang=js"
export * from "./MyProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports